import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import { PrimaryButton } from "../Buttons/Button";
import { ErrorToaster, SuccessToaster } from "../Toaster/Toaster";
import CarService from "app/apis/Goeasy/Car/CarService";
import DriverPriceService from "app/apis/Goeasy/Driver/DriverPriceService";

function DriverList({ handleClose, open, data }) {
  const [dataList, setDataList] = useState([]);

  const handleDataSubmission = async (driver_id) => {
    let obj = {
      id: data?.id,
      driver_id,
    };
    try {
      await CarService.assignDriver(obj);
      SuccessToaster("Driver Attached Successfully.");
      handleClose();
    } catch (error) {
      ErrorToaster(error);
      console.log("🚀 ~ handleDataSubmission ~ error:", error);
    }
  };

  const getAllDrivers = async () => {
    try {
      let { data, success } = await DriverPriceService.getDriver();
      if (success) {
        setDataList(data);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getAllDrivers();
  }, []);

  return (
    <Dialog
      open={open}
      fullWidth
      onClose={() => {
        handleClose();
      }}
      sx={{ "& .MuiDialog-paper": { borderRadius: "12px" } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textTransform: "capitalize",
        }}
      >
        Please Select Driver
        <IconButton
          onClick={() => {
            handleClose();
          }}
        >
          <CloseRounded />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box>
          {dataList.map((item) => (
            <Fragment key={item.id}>
              <Typography
                onClick={() => handleDataSubmission(item.id)}
                variant="body2"
                sx={{
                  mt: 1,
                  textTransform: "capitalize",
                  bgcolor: "#f5f5f5",
                  p: 1,
                  borderRadius: 1,
                  cursor: "pointer",
                }}
              >
                {item.name} - {item?.contact_no}
              </Typography>
            </Fragment>
          ))}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default DriverList;
